// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMBirthdayLevelPage_wrapper__EfDId"};